import ProjectsGrid from "../../components/disposables/Grid";
import { GridItemProps } from "../../components/disposables/Grid/GridItem";
import Layout from "../../layout/Layout";
import { RaftTypeE } from "../../types/raft";
import styles from "./styles.module.css";
import BlocksJrIcon from "../../assets/nav-buttons/marty-blocksjr.svg";
import BlocksIcon from "../../assets/nav-buttons/marty-blocks.svg";
import MartyUnpluggedIcon from "../../assets/nav-buttons/marty-unplugged.svg";
import ControllerIcon from "../../assets/nav-buttons/controller.svg";
import SensorsDashboardIcon from "../../assets/nav-buttons/sensors-dashboard.svg";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

const imageStyle: React.CSSProperties = {
  width: "80%",
  height: "90%",
  alignSelf: "center",
  justifySelf: "center",
};

const imageX = "10%";
const imageY = "5%";


function HomeScreen() {
  const { t } = useTranslation();

  const dummyGridContent: GridItemProps[] = [
    {
      type: "platform", title: t("home.blocksJr"), subtitle: "", href: "/blocks-jr", contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
      SvgIcon: () => <image x={imageX} y={imageY} href={BlocksJrIcon} style={imageStyle} />,
    },
    {
      type: "platform", title: t("home.blocks"), subtitle: "", href: "/blocks", contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
      SvgIcon: () => <image x={imageX} y={imageY} href={BlocksIcon} style={imageStyle} />,
    },
    {
      type: "platform",
      title: t("home.controller"), subtitle: "", contentTags: [RaftTypeE.MARTY], href: '/marty-controller',
      SvgIcon: () => <image x={imageX} y={imageY} href={ControllerIcon} style={imageStyle} />,
    },
    {
      type: "platform",
      title: t("home.sensors"), subtitle: "", contentTags: [RaftTypeE.MARTY, RaftTypeE.COG], href: '/sensor-dashboard',
      SvgIcon: () => <image x={imageX} y={imageY} href={SensorsDashboardIcon} style={imageStyle} />,
    },
  ];

  return (
    <Layout>
      <div className={styles.projectsSectionContainer}>
        <ProjectsGrid projects={dummyGridContent} />
      </div>
    </Layout>
  );
}

export default HomeScreen;
